/* eslint-disable import/no-anonymous-default-export */

import Content1 from "../Attachments/Images/Content1.png";
import ProfilePhoto from "../Attachments/Images/ProfilePhoto.jpeg";
import Content2 from "../Attachments/Images/Content2.png";
import Content3 from "../Attachments/Images/Content3.png";
import Content4 from "../Attachments/Images/Content4.png";
import Content5 from "../Attachments/Images/Content5.png";
import Post1 from "../Attachments/Images/post-1.webp";
import Post2 from "../Attachments/Images/post-2.webp";
import Post3 from "../Attachments/Images/post-3.webp";
import Post4 from "../Attachments/Images/post-4.webp";
import Post5 from "../Attachments/Images/post-5.webp";
import Post6 from "../Attachments/Images/post-6.webp";
import Post7 from "../Attachments/Images/post-7.webp";
import Post8 from "../Attachments/Images/post-8.webp";
import Post9 from "../Attachments/Images/post-9.webp";
import Post10 from "../Attachments/Images/post-10.webp";

const MainPageDataID = {
  title: "Rumah Hypno",
  name: "Melanie",
  quote:
    "“Orang datang ke terapi tidak untuk mengubah masa lalu mereka, tetapi masa depan mereka”",
  quotePeople: "-Milton H. Erickson-",
};

const AboutPageDataID = {
  section: "Tentang",
  content1: {
    title: "Siapa Kita?",
    description: (
      <>
        Rumah Hypno adalah klinik hipnoterapi keluarga yang berlokasi di Jakarta
        Selatan. Kami melayani terapi berbagai keluhan psikis maupun fisik
        ringan yang diakibatkan oleh ketidakseimbangan psikologis
        (psikosomatis), seperti kecanduan gadget/ alkohol/ rokok, depresi,
        stress, sulit focus, hypnoslimming, couple therapy, inner child, trauma,
        pengendalian emosi, atau gangguan psikometri lainnya.
        <br />
        <br />
        Bersama terapis yang professional, kami lakukan yang terbaik untuk anda.
      </>
    ),
    image: Content1,
  },
  profile: {
    title: "Profile",
    name: "MELANIE IVONE CH.,CHt.,CPHt",
    description1: (
      <>
        dilahirkan dan dibesarkan Di Jakarta, lulus dari Universitas Indonesia
        di tahun 2006. Ketertarikannya mengenai Psikologi Manusia dan keinginan
        yang kuat untuk membantu sesama dalam menyelesaikan berbagai masalah
        psikis maupun fisik, membuat Melanie menjadi seorang psikologi manusia
        enthusiast. <br />
        <br />
        <strong>Pengalaman sebagai Trainer:</strong>
      </>
    ),
    listDescription: [
      {
        list: "1. Trainer STIFIn di 2017 untuk Wilayah Nasional. STIFIn adalah singkatan dari Sensing, Thinking, Intuiting, Feeling and Insting yang merupakan sebuah konsep untuk mengindentifikasi kecerdasan manusia berdasarkan sistem operasi otak yang dominan dan dapat diketahui dengan memindai sidik jari.",
      },
      {
        list: "2. Trainer Motivasi Guru-Guru Aparatur Sipil Negara(ASN) di Bekasi tahun 2018, dan",
      },
      {
        list: "3. Trainer Motivasi & Entrepreneurship di Singapura Tahun 2019.",
      },
    ],
    description2: (
      <>
        <br />
        Kini Melanie telah tersertifikasi oleh{" "}
        <strong>IBH (The Indonesian Board of Hypnotherapy)</strong> sebagai
        Professional Hipnoterapis dan Hipnotis, yang akan dengan senang hati
        membantu mengatasi masalah anda, serta menjadikan versi lebih baik dari
        diri anda.
      </>
    ),
    image: ProfilePhoto,
  },

  content2: {
    title: "Apa itu Hipnoterapi?",
    description: (
      <>
        Setiap orang tentu memiliki rasa khawatirnya sendiri terhadap suatu hal.
        Namun, beberapa orang memiliki rasa khawatir yang berlebihan sehingga
        dapat dikategorikan sudah mengalami masalah terkait kesehatan mental.
        Bahkan, masalah tersebut sudah meningkat menjadi gangguan kecemasan atau
        anxiety. Gangguan tersebut harus segera mendapatkan penanganan agar
        tidak terus berkembang.
        <br /> Salah satu cara untuk mengatasi masalah dari kesehatan mental
        adalah dengan hipnoterapi. Metode ini disebut ampuh untuk membuat
        pikiran menjadi tenang sehingga segala masalah yang berhubungan dengan
        rasa khawatir, karena melalui teknik hypnotherapy memungkinkan seseorang
        untuk dapat me gakses alam bawah sadar yang menyimpan segala memori,
        nilai- nilai, prinsip, kepercayaan ( believe system) yang menjadi sumber
        pertimbangan dalam mengambil keputusan atau sumber pertimbangan dalam
        bertindak.
      </>
    ),
    image: Content2,
  },

  content3: {
    title: "Manfaat Hipnoterapi",
    description: (
      <>
        Hipnoterapi dapat memberikan potensi agar menjadi lebih baik dengan
        melakukan perawatan terkait kondisi medis tanpa membutuhkan pengobatan
        tambahan.
        <br />
        Ahli medis memasukkan hipnoterapi sebagai pilihan pengobatan yang aman
        dengan efek samping sangat minim. Mungkin cara ini tidak berhasil untuk
        semua orang dan kerap disebut sebagai terapi pelengkap.
        <br />
        <br />
        Seseorang yang mendapatkan terapi ini dapat merasakan beberapa manfaat,
        seperti meningkatnya rasa kesejahteraan secara menyeluruh, memperbaiki
        suasana hati, dan menghadirkan perasaan yang penuh dengan harapan.
        Hipnoterapi ini dapat digunakan untuk mengatasi beberapa kondisi,
        seperti sakit kronis, masalah konsentrasi, kontrol merokok, dan tentu
        saja kesehatan mental.
        <br />
        <br />
        Terapi ini dapat efektif untuk membantu seseorang mengurangi atau
        mengendalikan perasaan cemas, stres, dan sedih agar menjadi lebih baik.
        Hipnoterapi juga digunakan untuk mengatasi beberapa perilaku negatif
        yang dapat membuat depresi menjadi semakin buruk. Beberapa perilaku ini
        mungkin saja dapat berkembang menjadi sesuatu yang berbahaya bahkan
        mengganggu aktivitas harian.
        <br />
        Apabila kamu merasa dalam kondisi mental yang kurang baik, segera
        konsultasikan permasalahan kamu kepada seorang hipnoterapis agar kami
        bisa membantu kamu menjadi lebih baik.
      </>
    ),
    image: Content3,
  },

  content4: {
    title: "Cara Dilakukannya Hipnoterapi",
    description: (
      <>
        Sesi terapi ini umumnya dilakukan antara 60- 90 menit. Terapis akan
        menggunakan berbagai macam teknik relaksasi untuk memandu seseorang agar
        dapat memasuki keadaan hipnosis. Saat hal tersebut terjadi, kamu tentu
        masih dalam keadaan sadar, tetapi tubuh menjadi lebih rileks dan pikiran
        lebih responsif terhadap saran dari terapis.
        <br />
        <br />
        Berbagai saran yang akan dikatakan oleh terapis tergantung dari kondisi
        atau gangguan yang coba untuk diatasi.
        <br />
        <br />
        Hipnoterapi dapat membantu untuk menghilangkan kebiasaan yang tidak
        diinginkan atau tidak sehat dan menggantikannya dengan sesuatu yang
        lebih baik. Salah satu hal yang dapat dilakukan adalah meningkatkan
        kemampuan untuk mengontrol rasa sakit atau cemas, sehingga pola pikir
        yang buruk dapat dihilangkan agar masalah depresi teratasi.
      </>
    ),
    image: Content4,
  },

  content5: {
    title: "Seberapa Efektif kah Hipnoterapi?",
    image: Content5,
    description: `Sebuah penelitian pada tahun 2019 yang dilakukan oleh mahasiswa di
    Universitas Islam Walisongo Semarang Jurusan Psikoterapi, telah membuktikan
    bahwa Hipnoterapi efektif untuk mengurangi gejala kecemasan yang dialami
    oleh ibu hamil.`,
    addition: `Hipnoterapi terbukti efektif membantu orang mengatasi masalah yang
    berkaitan dengan stress dan juga terbukti efektif mengurangi berat badan,
    serta menjadikan seseorang memiliki pola hidup lebih sehat dengan mindset
    yang lebih baik.`,
  },
};

const TreatmentsPageDataID = {
  section: "Treatments",
  list1: [
    {
      title: "Hypno Parenting",
    },
    {
      title: "Hypno Slimming",
    },
    {
      title: "Hypno Inner Child",
    },
    {
      title: "Couple Therapy",
    },
    {
      title: "Pengendalian Emosi",
    },
    {
      title: "Meningkatkan Percaya Diri",
    },
    {
      title: "Meningkatkan Fokus",
    },
  ],
  list2: [
    {
      title: "Meningkatkan Skill Public Speaking",
    },
    {
      title: "Mengatasi Gangguan Kesulitan Belajar",
    },
    {
      title: "Mengatasi Stress",
    },
    {
      title: "Mengatasi Depresi",
    },
    {
      title: "Mengatasi Fobia",
    },
  ],
  list3: [
    {
      title: "Mengatasi Trauma",
    },
    {
      title: "Mengatasi Kesedihan Mendalam",
    },
    {
      title: "Mengatasi Overthinking",
    },
    {
      title: "Mengatasi Kecanduan (Rokok, Alkohol, DLL.)",
    },
    {
      title: "Mengatasi Gangguan Psikosomatik Lainnya",
    },
  ],
};

const PricingPageDataID = {
  pricing1: {
    Title: "Ceria 1",
    Price: "IDR 1,000,000",
    Benefits: "Hanya 1 Sesi",
  },
  pricing2: {
    Title: "Ceria 2",
    Price: "IDR 1,800,000",
    Benefits: "2 Sesi",
  },
  pricing3: {
    Title: "Ceria 3",
    NormalPrice: "IDR 4,000,000",
    PriceNow: "IDR 1.500.000",
    Benefits: (
      <>
        4 Sesi
        <br />
        Diskon untuk waktu yang terbatas
      </>
    ),
  },

  offer: {
    Title: "PROMO UNTUK WAKTU TERBATAS!!",
    content:
      "Ajak siapa saja booking sesi di Rumah Hypno sebanyak 3 Orang, dan Dapatkan GRATIS 1X Sesi Hypnotherapy untuk Kamu!",
  },
};

const FaqPageDataID = [
  {
    question: "Apakah Hipnoterapi Aman?",
    answer:
      "Hipnoterapi Adalah 100% Aman. Itu Adalah Metode Penyembuhan Dengan Menggunakan Kekuatan Pikiran Bawah Sadar. Hipnoterapi Adalah Penyembuhan Diri, Hipnoterapi Merestrukturisasi Pikiran Klien. Persyaratan Hipnoterapi Pertama Adalah Keinginan Klien Untuk Melakukan Terapi. Teknik Alternatif Yang Lebih Aman Diterapkan Untuk Klien Dengan Kondisi Tertentu Seperti Wanita Hamil Atau Memiliki Masalah Jantung.",
  },
  {
    question: "Apakah Klien Kehilangan Kontrolnya Dan Mengungkap Rahasianya?",
    answer:
      "Selama Terapi, Klien Akan Tetap Sadar Dan Menyadari Apa Yang Terjadi Selama Proses. Terapis Akan Membantu Klien Untuk Santai Dan Fokus Untuk Menjelajahi Akar Penyebab.",
  },
  {
    question: "Apakah Hypnoterapi Sama Dengan Pencucian Otak?",
    answer:
      "Tentu Saja Tidak. Hipnoterapi Bukan Proses Pencucian Otak. Terapis Membutuhkan Ijin Klien Untuk Mengakses Data Memori Di Pikiran Bawah Sadar Yang Mengijinkan Untuk Membuka Data Memori Yang Diperlukan Dalam Proses Restrukturisasi",
  },
  {
    question:
      "Apakah Hypnosis Berkinerja Sama Seperti Tv Show Dimana Klien Menjadi Tidur Atau Terhipnotis?",
    answer:
      "Berbeda. Hipnoterapi Adalah Memberikan Penyembuhan Untuk Pikiran Alam Bawah Sadar Ketika Klien Dalam Kesadaran Relaks Dan Kontrol Penuh.",
  },
  {
    question: "Kasus Apa Saja Yang Dapat Diatasi Dengan Hipnoterapi?",
    answer:
      "Pada Dasarnya Semua Psikosomatik (Yang Disebabkan Oleh Pikiran Atau Pikiran) Atau Emosi Negatif Seperti: Sedih, Marah, Frustrasi, Kecewa, Dendam, Patah Hati, Takut, Khawatir, Tidak Percaya Diri, Dll. Dapat Membantu Mengatasi Masalah Hubungan Keluarga (Seperti Sebagai Pasangan, Orang Tua, Anak-anak, Remaja). Hipnoterapi Juga Dapat Menyembuhkan Insomnia, Trauma, Fobia, Kecanduan Gadget, Merokok Dan Kebiasaan Buruk Lainnya.",
  },
  {
    question: "Apakah Ada Jaminan Bahwa Konseling Saya Akan Rahasia?",
    answer:
      "Informasi Klien Akan Didokumentasikan Secara Rahasia. Terapis Harus Mengikuti Aturan Etika Dari Awgi. Jika Ada Bagian Dari Konseling Yang Akan Dibagikan Untuk Tujuan Pendidikan, Terapis Akan Meminta Izin Klien Dan Menggantinya Dengan Nama Fiksi.",
  },
  {
    question: "Apakah Ada Jaminan Bahwa Saya Akan Segera Sembuh?",
    answer:
      "Dasar Hipnoterapi Adalah 'Kontrak Berorientasi Usaha', Bukan 'Kontrak Berorientasi Hasil'. Terapis Akan Melakukan Yang Terbaik Untuk Mengatasi Masalah Klien. Banyak Dari Klien Kami Telah Mengalami Perubahan Positif Dalam Hidup Setelah Sesi Hipnoterapi.",
  },
  {
    question: "Apakah Bedanya Hipnoterapi Dengan Sugesti Biasa?",
    answer:
      "Hipnoterapi Memiliki Keunggulan Yaitu Kita Dapat Berkomunikasi Dua Arah Dengan Pikiran Bawah Sadar Kita. Sedangkan Sugesti Biasa Tidak Memfasilitasi Respon Dari Pikiran Bawah Sadar.",
  },
  {
    question: "Apakah Hipnoterapi Mengubah Kepribadian Dasar Seseorang?",
    answer:
      "Jawabannya Adalah Tidak. Prosesnya Hanya Akan Fokus Pada Isu Spesifik Yang Dibutuhkan Klien.",
  },
];

const PostsPageDataID = [
  {
    image: Post1,
    postTitle:
      "Depresi, Ketidakamanan & masih banyak lagi yang bisa Dihilangkan dengan Hipnoterapi",
    id: 1,
    link: "*/section_1",
  },
  {
    image: Post2,
    postTitle: "Mengatur amarah",
    id: 2,
    link: "*/section_2",
  },
  {
    image: Post3,
    postTitle: "Fobia",
    id: 3,
    link: "*/section_3",
  },
  {
    image: Post4,
    postTitle: "Terapi Pasangan",
    id: 4,
    link: "*/section_4",
  },
  {
    image: Post5,
    postTitle: "Hipnoslimming",
    id: 5,
    link: "*/section_5",
  },
  {
    image: Post6,
    postTitle: "Kecanduan (Merokok, Narkoba, Alkoholisme, Dll)",
    id: 6,
    link: "*/section_6",
  },
  {
    image: Post7,
    postTitle: "Hipnosis Batin Anak",
    id: 7,
    link: "*/section_7",
  },
  {
    image: Post8,
    postTitle: "Berhenti Merokok",
    id: 8,
    link: "*/section_8",
  },
  {
    image: Post9,
    postTitle: "Hipnoterapi insomnia",
    id: 9,
    link: "*/section_9",
  },
  {
    image: Post10,
    postTitle: "Apakah Hipnoterapi berhasil?",
    id: 10,
    link: "*/section_10",
  },
];

export {
  MainPageDataID,
  AboutPageDataID,
  TreatmentsPageDataID,
  PricingPageDataID,
  FaqPageDataID,
  PostsPageDataID,
};
